import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "./helper";

export const loansActionSlice = createApi({
  baseQuery,
  reducerPath: "loansApi",
  tagTypes: ["LoanRemarks"],
  endpoints: (build) => ({
    getLoanRemarks: build.query<
      LoanRemarkResponseDto,
      {
        entityId: string;
        loanType: "TERM_LOAN" | "RETAIL_OD" | "RETAIL_OD_DRAWDOWN";
      }
    >({
      query: ({ entityId, loanType }) => ({
        url: `/loan/${entityId}/getRemarks`,
        method: "GET",
        params: {
          loanType,
        },
      }),
      providesTags: ["LoanRemarks"],
    }),
    addLoanRemark: build.mutation<{ _id: string }, AddRemarkRequestDto>({
      query: ({ entityId, loanType, remark, remarkDate }) => {
        return {
          url: `/loan/${entityId}/remarks`,
          method: "PATCH",
          params: {
            loanType,
          },
          body: { remark, remarkDate },
        };
      },
      invalidatesTags: ["LoanRemarks"],
    }),
  }),
});

type LoanRemarkResponseDto = LoanRemark[];
type AddRemarkRequestDto = {
  entityId: string;
  loanType: "TERM_LOAN" | "RETAIL_OD" | "RETAIL_OD_DRAWDOWN";
} & AddRemarks;

export type LoanRemark = {
  remark: string;
  adminId: string;
  remarkDate: string;
};

export type AddRemarks = {
  remark: string;
  remarkDate: string;
};

export const { useGetLoanRemarksQuery, useAddLoanRemarkMutation } =
  loansActionSlice;
